import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CategoriesMenuState, StateWithCategoriesMenu } from '../categories-menu-state';
import { getFeatureState } from './feature.selector';

export const getCategoriesMenuRootNodeIdState: MemoizedSelector<
  StateWithCategoriesMenu,
  StateUtils.LoaderState<string>
> = createSelector(getFeatureState, (state: CategoriesMenuState) => state.rootNodeId);

export const getCategoriesMenuRootNodeIdValue: MemoizedSelector<StateWithCategoriesMenu, string> = createSelector(
  getCategoriesMenuRootNodeIdState,
  (state: StateUtils.LoaderState<string>) => StateUtils.loaderValueSelector(state),
);

export const getCategoriesMenuRootNodeIdLoading: MemoizedSelector<StateWithCategoriesMenu, boolean> = createSelector(
  getCategoriesMenuRootNodeIdState,
  (state: StateUtils.LoaderState<string>) => StateUtils.loaderLoadingSelector(state),
);

export const getCategoriesMenuRootNodeIdError: MemoizedSelector<StateWithCategoriesMenu, boolean> = createSelector(
  getCategoriesMenuRootNodeIdState,
  (state: StateUtils.LoaderState<string>) => StateUtils.loaderErrorSelector(state),
);

export const getCategoriesMenuRootNodeIdSuccess: MemoizedSelector<StateWithCategoriesMenu, boolean> = createSelector(
  getCategoriesMenuRootNodeIdState,
  (state: StateUtils.LoaderState<string>) => StateUtils.loaderSuccessSelector(state),
);
